import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/reducers";
import { useRouter } from "@/shared/utils/hooks/useRouter";
import ArrowLeft from "@/components/shared/icons/web/ArrowLeft";
import { useTranslation } from "react-i18next";
import { getChatUrl } from "@/shared/utils/ultils";
import { CSpinner } from "@coreui/react-pro";

const Message = () => {
  const { t } = useTranslation();
  const { navigate } = useRouter();
  const { user } = useSelector((state: RootState) => state.authentication);
  const [loading, setLoading] = useState(true);

  const url = useMemo(() => getChatUrl(user), [user]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        maxWidth: 500,
        margin: "0 auto",
        height: "100%",
        zIndex: 999999,
        backgroundColor: "#fff",
        overflow: "hidden",
      }}
    >
      {/* Nút Back ở góc trên cùng bên phải (hỗ trợ tai thỏ iPhone) */}
      <button
        type="button"
        onClick={() => navigate(-1)}
        aria-label={t("Quay lại")}
        style={{
          position: "absolute",
          top: "max(12px, env(safe-area-inset-top))",
          right: 12,
          zIndex: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 4,
          padding: "6px 12px",
          borderRadius: "20px",
          backgroundColor: "rgba(0, 0, 0, 0.45)",
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
          color: "#fff",
          border: "1px solid rgba(255, 255, 255, 0.25)",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
          fontSize: "13px",
          lineHeight: 1,
        }}
      >
        <ArrowLeft style={{ width: 14, height: 14 }} />
        <span>{t("Quay lại")}</span>
      </button>

      {loading && (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 5,
            background: "#f7f9fa",
          }}
        >
          <CSpinner
            variant="grow"
            style={{ width: 28, height: 28, color: "#0262b0" }}
          />
        </div>
      )}

      <iframe
        title="Customer Support Chat"
        src={url}
        onLoad={() => setLoading(false)}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        allow="camera; microphone; clipboard-read; clipboard-write;"
      />
    </div>
  );
};

export default Message;


